<template>
  <section class="section is-medium background-black">
    <section class="section">
      <div class="container">
        <div class="columns">
          <div class="column">
            <div class="box">
              <h1 class="title is-1 is-2-touch has-text-weight-bold is-capitalised has-text-white">
                Why do we need to
                <span class="marker">learn martial arts</span>?
              </h1>
              <h2 class="subtitle has-text-grey-light is-6">
                For years, our martial arts have been split across various art
                forms. Its time to bring it back together, as one!
              </h2>
              <b-button
                style="font-size: 1rem;"
                class="button is-primary has-text-black has-text-weight-semibold cta is-uppercase"
                tag="a"
                icon-left="play"
                size="is-medium"
              >
                <span
                  class="wistia_embed wistia_async_cbrauphhzz popover=true popoverContent=link"
                  style="display:inline;position:relative"
                >
                  <span href="#">Watch Video</span>
                </span>
              </b-button>
            </div>
          </div>
          <div class="column"></div>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.bgr {
  background-image: url("../assets/yinyang.png");
  background-position: center center;
  background-repeat: no-repeat;
  background-position: right;
  // background-size: 300px 300px;
}
.marker {
  background-color: #eb272c;
  font-family: inherit;
  color: #000;
  font-weight: 800;
  display: inline;
  padding: 3px;
  vertical-align: center;
  /* margin-left: -5px; */
  line-height: 1em;
}
.column-pad {
  padding: 2em;
}

.background-black {
  // background-color: #11111160;
  // background-image: url("../assets/hexagons.svg") !important;
  // box-shadow: 0px 0px 60px 30px black inset;
}

.cta {
  padding: 1.5em;
  font-weight: 700 !important;
}

.box {
  padding: 0px;
  max-width: 700px;
  background-color: transparent;
  border: 0px;
  //box-shadow: 0 5px 20px rgba(0, 0, 0, 0.6);
  box-shadow: none;
}
</style>
